// @ts-nocheck
import { z } from "zod";
export const startSectionSchema = z.object({ "id": z.string().default("start"), "name": z.string().default("Start"), "section_type": z.literal("start").optional(), "edges": z.array(z.object({ "target": z.string(), "condition": z.string(), "label": z.union([z.string(), z.null()]).default(null) })).optional() });
